<template>
    <div>
        <app-tooltip-button
			class="back-button"
			:img="'/static/img/icons/flecha_izquierda.svg'"
			:width="25"
			:text="'Regresar'"
			@click-icon="backRoute"
		/>
    </div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import { mapGetters } from 'vuex';

function backRoute() {
	const getBread = [...this.getBreadCrumbs];
	getBread.pop();
	const lastRoute = getBread[getBread.length - 1];
	const options = {
		meta: lastRoute.meta,
		params: lastRoute.params,
		query: lastRoute.query,
	};
	this.goTo(lastRoute.name, options);
}

export default {
	name: 'back-button-route',
	components: {
		appTooltipButton,
	},
	computed: {
		...mapGetters('route', [
			'getBreadCrumbs',
		]),
	},
	methods: {
		backRoute,
	},
};
</script>

<style lang="scss" scoped>
	.back-button {
		margin-left: 50px;
	}
</style>


// WEBPACK FOOTER //
// src/components/shared/back-button-route.vue